import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import SideBar from "../components/SideBar/SideBar";
import BrowseContentSideBarContent from "../components/ContentSelection/BrowseContentSideBarContent";
import Header from "../components/ContentSelection/Header";
import AssetList from "../components/AssetList";
import { actions as assetsActions } from "../actions/assets";
import { actions as appActions } from "../actions/app";
import { actions as contentActions } from "../actions/content";
import SidebarState from "../constants/sidebarState";
import Footer from "../components/Footer";
import App from "../constants/app";
import LuciPropTypes from "../propTypes/";
import AssetType from "../constants/assetTypes";
import Pagination from "../components/Pagination";
import {
  Container,
  MainContent,
  StickyHeader,
  StickyFooter
} from "../styled-components/Layout";
import BrowseContentFooter from "../components/ContentSelection/BrowseContentFooter";
import BuildGraphicLayout from "./BuildGraphicLayout";
import SlidingOverlay from "../components/SlidingOverlay";
import TemplateSelectionLayout from "./TemplateSelectionLayout";
import Clipper from "../util/clipper";
import AppMode from "../constants/appMode";
import DataEngineMessenger from "../util/deMessaging";
import localize from "../util/localizeUtils";
import ClipperMode from "../constants/clipperMode";
import Settings from "../settings";

const PaginationContainer = styled.div`
  position: fixed;
  bottom: ${props => props.bottom || App.FOOTER_HEIGHT};
  right: 1.2rem;
  flex-direction: column;
`;

const MainContentDiv = styled(MainContent)`
  flex-direction: row;
  display: flex;
  height: 100%;
`;

const SubContainer = styled(Container)`
  width: 100%;
`;

const deBucket = "luci.messaging";

class ContentLayout extends React.Component {
  constructor(props) {
    super(props);

    this.clipper = null;
    this.deMessenger = null;

    this.state = {
      buildGraphicDialogVisible: false,
      templateSelectionOverlayVisible: false,
      selectedContent: null
    };
  }

  UNSAFE_componentWillMount() {
    const {
      authenticated,
      userId,
      sessionId,
      containerType,
      assetType
    } = this.props;
    this.props.changeFooterHeight("2.5rem");
    this.props.changeSidebarState(SidebarState.NONE);

    if (authenticated && assetType === "video") {
      this.clipper = new Clipper(userId, sessionId, containerType !== "NONE");
      this.deMessenger = this.deConnection(sessionId);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.configLoaded && nextProps.configLoaded) {
      this.props.changeFooterHeight("2.5rem");
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const userLoggedIn = nextProps.authenticated;
    const userChanged = this.props.userId !== nextProps.userId;
    const contentNeedUpdate =
      nextProps.needUpdate || nextProps.content.localcontent.needUpdate;
    const contentLoading = nextProps.contentLoading;
    const assetTypeChanged = this.props.assetType !== nextProps.assetType;

    if (this.props.initialized) {
      if (
        !nextProps.categoriesLoading &&
        ((userChanged && userLoggedIn) || assetTypeChanged)
      ) {
        this.props.getCategories(nextProps.assetType || "image");
      }

      if (
        !nextProps.filtersLoading &&
        ((userChanged && userLoggedIn) || assetTypeChanged)
      ) {
        this.props.getFilterOptions(nextProps.userId, nextProps.assetType);
      }
    }

    if (
      userLoggedIn &&
      nextProps.initialized &&
      !contentLoading &&
      contentNeedUpdate &&
      !nextProps.categoriesLoading
    ) {
      this.props.getContent(
        nextProps.assetType,
        nextProps.content.localcontent.searchType
      );
    }

    if (assetTypeChanged && nextProps.assetType === "video") {
      this.clipper = null;
      this.clipper = new Clipper(
        nextProps.userId,
        nextProps.sessionId,
        nextProps.containerType !== "NONE"
      );
    }

    if (
      assetTypeChanged &&
      nextProps.assetType === "video" &&
      userLoggedIn &&
      nextProps.appMode !== AppMode.CLIPPER_ACTIVE
    ) {
      this.clipper = new Clipper(
        nextProps.userId,
        nextProps.sessionId,
        nextProps.containerType !== "NONE"
      );
      this.deMessenger = this.deConnection(nextProps.sessionId);
    } else if (
      nextProps.assetType === "video" &&
      this.clipper &&
      userChanged &&
      userLoggedIn
    ) {
      this.clipper = null;
      this.clipper = new Clipper(
        nextProps.userId,
        nextProps.sessionId,
        nextProps.containerType !== "NONE"
      );
      this.deMessenger = this.deConnection(nextProps.sessionId);
    } else if (nextProps.assetType === "image" && this.clipper) {
      this.clipper = null;
      this.deMessenger = this.deConnection(nextProps.sessionId);
    }
  }

  componentWillUnmount() {
    if (this.deMessenger) {
      this.deMessenger.disconnect();
      this.deMessenger = null;
    }
  }

  openBuildGraphicDialog = () => {
    if (this.props.assetType === "image") {
      this.setState({
        buildGraphicDialogVisible: true
      });
    } else if (
      this.props.assetType === "video" &&
      this.clipper &&
      Settings.enableClipper
    ) {
      this.openClipper();
    }
  };

  openClipper = () => {
    this.clipper.openClipper();

    setTimeout(
      () =>
        this.deMessenger
          .sendMessage({
            type: "INITIALIZE_CLIPPER",
            mode: ClipperMode.PUBLISH_ONLY
          })
          .then(reply => {
            if (reply.type === "CLIPPER_INITIALIZED") {
              this.props.setAppMode(AppMode.CLIPPER_ACTIVE);
            }
            return Promise.resolve();
          })
          .catch(err => {
            console.log("Sending message to data engine failed.");
            console.log(err);
          }),
      3000
    );
    this.deMessenger.onMessage(message => {
      const messageData = message.data || message;
      switch (messageData.type) {
        case "CLIPPER_CLOSED":
          this.props.setAppMode(AppMode.NORMAL);
          break;
        default:
          break;
      }
    });
  };

  closeBuildGraphicDialog = () => {
    this.setState({
      buildGraphicDialogVisible: false
    });
    this.props.getContent(this.props.assetType, "localcontent");
  };

  bindContentLayoutShortcuts = () => {
    if (this.browseContentSidebar) {
      this.browseContentSidebar.getWrappedInstance().bindShortcuts();
    }
    if (this.header) {
      this.header.getWrappedInstance().bindShortcuts();
    }
  };

  unbindContentLayoutShortcuts = () => {
    if (this.browseContentSidebar) {
      this.browseContentSidebar.getWrappedInstance().unbindShortcuts();
    }
    if (this.header) {
      this.header.getWrappedInstance().unbindShortcuts();
    }
  };

  bindTemplateOverlayShortcuts = () => {
    if (this.templateSelectionLayout) {
      this.templateSelectionLayout.getWrappedInstance().bindShortcuts();
    }
  };

  unbindTemplateOverlayShortcuts = () => {
    if (this.templateSelectionLayout) {
      this.templateSelectionLayout.getWrappedInstance().unbindShortcuts();
    }
  };

  openTemplateSelectionOverlay = contentItem => {
    this.unbindContentLayoutShortcuts();
    this.bindTemplateOverlayShortcuts();
    if (this.props.templateType === AssetType.GRAPHIC_MOS_OBJECT) {
      this.props.changeAssetType(AssetType.GRAPHIC_TEMPLATE);
    }
    this.props.changeReplaceableCategories(contentItem.categories);
    this.props.getAssets(this.props.assetType, true);
    this.setState({
      templateSelectionOverlayVisible: true,
      selectedContent: contentItem
    });
  };

  closeTemplateSelectionOverlay = () => {
    this.unbindTemplateOverlayShortcuts();
    this.bindContentLayoutShortcuts();
    this.props.changeReplaceableCategories();
    this.setState({
      templateSelectionOverlayVisible: false,
      selectedContent: null
    });
  };

  deConnection = sessionId => {
    if (this.deMessenger) {
      this.deMessenger.disconnect();
      this.deMessenger = null;
    }
    return new DataEngineMessenger(
      deBucket,
      `${deBucket}.${sessionId}-clipper`,
      `${deBucket}.${sessionId}-luci`
    );
  };

  render() {
    const {
      content,
      toggleFavorite,
      sidebar,
      contentRequestQueued,
      changePage,
      reload,
      shortcuts,
      footerHeight
    } = this.props;
    const paddingRight =
      sidebar === SidebarState.LEFT_ONLY || sidebar === SidebarState.BOTH
        ? App.SIDEBAR_WIDTH
        : "0";
    return (
      <Container overflowFix>
        <MainContentDiv>
          <SideBar width={App.SIDEBAR_WIDTH} left>
            <BrowseContentSideBarContent
              ref={r => (this.browseContentSidebar = r)}
            />
          </SideBar>
          <SlidingOverlay
            visible={this.state.templateSelectionOverlayVisible}
            title={localize("templatesOverlayTitle")}
            onClose={this.closeTemplateSelectionOverlay}
          >
            <TemplateSelectionLayout
              ref={r => (this.templateSelectionLayout = r)}
              selectedContent={this.state.selectedContent}
              onConfirmAssetSelected={this.closeAssetBrowserDialog}
            />
          </SlidingOverlay>
          <SlidingOverlay
            title={localize("compositorOverlayTitle")}
            onClose={this.closeBuildGraphicDialog}
            visible={this.state.buildGraphicDialogVisible}
          >
            <BuildGraphicLayout
              onAssembleComplete={this.closeBuildGraphicDialog}
              visible={this.state.buildGraphicDialogVisible}
            />
          </SlidingOverlay>
          <SubContainer>
            <StickyHeader>
              <Header ref={r => (this.header = r)} />
            </StickyHeader>
            <MainContent>
              <AssetList
                assetList={content.localcontent.contentList}
                paddingRight={paddingRight}
                toggleFavorite={(id, favorite) =>
                  toggleFavorite(id, favorite, "localcontent")
                }
                loading={
                  (contentRequestQueued || content.localcontent.loading) &&
                  !this.state.templateSelectionOverlayVisible
                }
                onDoubleClick={this.openTemplateSelectionOverlay}
                showFilePath
                error={content.localcontent.error}
                reload={reload}
              />
              <PaginationContainer bottom={footerHeight}>
                <Pagination
                  nextPageShortcut={shortcuts.nextPage}
                  prevPageShortcut={shortcuts.prevPage}
                  totalPages={content.localcontent.totalPages}
                  currentPage={content.localcontent.pageNumber}
                  buffer={2}
                  onChange={newPage => changePage(newPage, "localcontent")}
                />
              </PaginationContainer>
            </MainContent>
          </SubContainer>
        </MainContentDiv>
        <StickyFooter>
          <Footer>
            <BrowseContentFooter
              openBuildGraphicDialog={this.openBuildGraphicDialog}
            />
          </Footer>
        </StickyFooter>
      </Container>
    );
  }
}

ContentLayout.defaultProps = {
  selectedAssetId: null,
  sessionId: null
};

ContentLayout.propTypes = {
  sidebar: PropTypes.string.isRequired,
  // eslint-disable-next-line
  appMode: PropTypes.string.isRequired,
  content: LuciPropTypes.Content.isRequired,
  containerType: PropTypes.string.isRequired,
  authenticated: PropTypes.bool.isRequired,
  toggleFavorite: PropTypes.func.isRequired,
  getContent: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  contentRequestQueued: PropTypes.bool.isRequired,
  changeSidebarState: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  sessionId: PropTypes.string,
  assetType: PropTypes.string.isRequired,
  templateType: PropTypes.string.isRequired,
  getFilterOptions: PropTypes.func.isRequired,
  shortcuts: PropTypes.shape({
    nextPage: PropTypes.arrayOf(PropTypes.string),
    prevPage: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  getCategories: PropTypes.func.isRequired,
  changeAssetType: PropTypes.func.isRequired,
  getAssets: PropTypes.func.isRequired,
  changeReplaceableCategories: PropTypes.func.isRequired,
  setAppMode: PropTypes.func.isRequired,
  // eslint-disable-next-line
  contentLoading: PropTypes.bool.isRequired,
  footerHeight: PropTypes.string.isRequired,
  changeFooterHeight: PropTypes.func.isRequired,
  configLoaded: PropTypes.bool.isRequired,
  initialized: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  sidebar: state.app.sidebar,
  appMode: state.app.appMode,
  containerType: state.app.containerType,
  content: state.content.contentList,
  userId: state.auth.user.userId,
  authenticated: state.auth.authenticated,
  contentRequestQueued: state.content.contentRequestQueued,
  needUpdate: state.content.needUpdate,
  contextList: state.content.contextList,
  categoryList: state.content.categoryList,
  assetType: state.content.assetType,
  sessionId: state.auth.user.sessionId,
  templateType: state.assets.assetType,
  shortcuts: state.keyShortcuts.shortcuts,
  categoriesLoading: state.content.categoriesLoading,
  contextsLoading: state.assets.contextsLoading,
  filtersLoading: state.content.filtersLoading,
  contentLoading: state.content.contentLoading,
  footerHeight: state.app.footerHeight,
  configLoaded: state.app.configLoaded,
  initialized: state.app.initialized,
  initializing: state.app.initializing
});

const mapActionCreators = {
  toggleFavorite: contentActions.toggleFavorite,
  getFilterOptions: contentActions.getFilterOptions,
  getCategories: contentActions.getCategories,
  getContent: contentActions.getContent,
  changeSidebarState: appActions.changeSidebarState,
  changePage: contentActions.changePage,
  reload: contentActions.reload,
  changeAssetType: assetsActions.changeAssetType,
  getAssets: assetsActions.getAssets,
  changeReplaceableCategories: contentActions.changeReplaceableCategories,
  setAppMode: appActions.setAppMode,
  changeFooterHeight: appActions.changeFooterHeight
};

export default connect(mapStateToProps, mapActionCreators)(ContentLayout);



// WEBPACK FOOTER //
// ./app/layouts/ContentLayout.js